import { Clock } from "lucide-react";
import { Reveal } from "./Reveal";

const SERVICES = [
  { day: "Sunday", name: "Sunday Worship", time: "10:00 AM – 12:00 PM" },
  { day: "Monday", name: "Prayer", time: "5:00 – 6:00 PM" },
  { day: "Tuesday", name: "Prayer", time: "5:00 – 6:00 PM" },
  { day: "Wednesday", name: "WED 3for30 Service", time: "6:00 – 7:30 PM" },
  { day: "Thursday", name: "Prayer", time: "5:00 – 6:00 PM" },
];

export default function ServiceTimes() {
  return (
    <section id="times" data-testid="service-times-section" className="relative py-28 md:py-40 bg-[#0a0a0a] border-y border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-4">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.3em] text-[#4169E1] mb-6">Join Us</p>
              <h2 className="font-display font-bold uppercase tracking-tighter leading-none text-4xl sm:text-5xl md:text-6xl">
                Service times
              </h2>
              <p className="mt-8 text-base text-zinc-400 leading-relaxed">
                6810 Presidential Drive
                <br />
                Jackson, MS 39213
                <br />
                <span className="text-zinc-500">Presidential Hills Subdivision</span>
              </p>
              <div className="mt-8 inline-flex items-center gap-2 text-sm text-zinc-400">
                <Clock className="w-4 h-4 text-[#4169E1]" />
                Doors open 30 minutes before each service
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="border-t border-white/10">
              {SERVICES.map((s, i) => (
                <Reveal key={s.day} delay={i * 0.08}>
                  <div
                    data-testid={`service-row-${s.day.toLowerCase()}`}
                    className="group grid grid-cols-12 gap-x-6 gap-y-1 items-baseline py-8 md:py-10 border-b border-white/10"
                  >
                    <span className="col-span-12 sm:col-span-4 font-display font-bold uppercase tracking-tight text-3xl group-hover:text-[#4169E1] transition-colors duration-500">
                      {s.day}
                    </span>
                    <span className="col-span-12 sm:col-span-3 text-sm uppercase tracking-widest text-zinc-400">
                      {s.name}
                    </span>
                    <span className="col-span-12 sm:col-span-5 sm:text-right font-display font-semibold text-2xl md:text-3xl text-zinc-200 whitespace-nowrap">
                      {s.time}
                    </span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
